<template>
  <div class="animated fadeIn">
    <Forms ref="frmSearch"
      :title="$lang.EmployeeBoard.AddEmployee.TitleForm"
      :showHelp="false"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row" style="background-color: #f9f9f9; padding-top: 7px; padding-bottom: 10px; border-radius: 5px; border: solid 1px #efefef;">
        <div class="col-md-4">
          <label>{{$lang.EmployeeBoard.AddBoard.LabelOrder}}:</label>
          <div class="input-group">
            <strong>{{RequestNumber}}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <label>{{$lang.EmployeeBoard.AddBoard.LabelResponsible}}:</label>
          <div class="input-group">
            <strong>{{Responsible}}</strong>
          </div>
        </div>
        <div class="col-md-4">
          <label>{{$lang.EmployeeBoard.AddBoard.LabelConstructions}}:</label>
          <div class="input-group">
            <strong>{{ObraRH}}</strong>
          </div>
        </div>
      </div>
      <div class="form-group row pt-3">
        <div class="col-md-12">
          <label for="txtInsured"><small class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelName}}:</label>
          <autocomplete-z ref="employeeTypeahead"
            :placeholder="$lang.EmployeeBoard.AddEmployee.PlaceholderName"
            iconClass="fas fa-user"
            :serializer="s => s.codigo + ' - ' + s.nome"
            :deboundLength="2"
            :formField="form.funcionario"
            v-on:search="onSearchEmployee"
            v-on:changeCode="onChangeCodeEmployee"
            v-on:hit="onLoadEmployee" />
            <!--<span class="input-group-addon"><i class="fas fa-search"></i></span>-->
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-8">
          <label for="cbxInsure">{{$lang.EmployeeBoard.AddEmployee.LabelRole}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.cargoID.value" :options="form.cargoID.options" :readonly="true">
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
         <div class="col-md-4">
          <label for="cbxInsure"><small v-show="form.situacao.required" class="text-danger">*</small> CTD:</label>
          <div class="input-group">
            <b-form-select v-model="form.situacao.value" :options="form.situacao.options" >
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <option value="C">{{$lang.EmployeeBoard.AddEmployee.ValueC}}</option>
                <option value="T">{{$lang.EmployeeBoard.AddEmployee.ValueT}}</option>
                <option value="D">{{$lang.EmployeeBoard.AddEmployee.ValueD}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2 pb-2 mt-4 mb-2" style="background-color: #ccc;">
        <div class="col-md-12">
          <strong><i class="fas fa-user-tie"></i> {{$lang.EmployeeBoard.AddEmployee.GroupHR}}</strong>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="txtCodePeople"><small v-show="form.admissao.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelAdmission}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtAdmissionDate"
                          v-model="form.admissao.value"
                          :required="form.admissao.required"
                          :state="form.admissao.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtCodePeople"><small v-show="form.dataExperiencia1.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelFirstExperience}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtExperience1Date"
                          v-model="form.dataExperiencia1.value"
                          :required="form.dataExperiencia1.required"
                          :state="form.dataExperiencia1.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtCodePeople"><small v-show="form.dataExperiencia2.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelSecondExperience}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtExperience2Date"
                          v-model="form.dataExperiencia2.value"
                          :required="form.dataExperiencia2.required"
                          :state="form.dataExperiencia2.state" />
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-4">
          <label for="txtCodePeople"><small v-show="form.avisoPrevio.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelEarlyWarning}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtPreviousNoticeDate"
                          v-model="form.avisoPrevio.value"
                          :required="form.avisoPrevio.required"
                          :state="form.avisoPrevio.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtCodePeople"><small v-show="form.ferias.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelVacation}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtVacationDate"
                          v-model="form.ferias.value"
                          :required="form.ferias.required"
                          :state="form.ferias.state" />
          </div>
        </div>
        <div class="col-md-4">
          <label for="txtCodePeople"><small v-show="form.dataAfastamento.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelMedicalLeave}}:</label>
          <div class="input-group">
            <b-form-input type="date"
                          name="txtAbsenceDate"
                          v-model="form.dataAfastamento.value"
                          :required="form.dataAfastamento.required"
                          :state="form.dataAfastamento.state" />
          </div>
        </div>
      </div>
      <div class="form-group row pt-2 pb-2 mt-4 mb-2" style="background-color: #ccc;">
        <div class="col-md-12">
          <strong><i class="fas fa-utensils"></i> {{$lang.EmployeeBoard.AddEmployee.GroupFoodAid}} </strong>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <label for="txtInsured"><small v-show="form.refeicaoQuantidade.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelQuantityMealPerDay}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-calculator"></i></span>
            <money class="form-control form-control-10 text-right"
                          v-bind="integerFormat"
                          placeholder="0"
                          v-model="form.refeicaoQuantidade.value"
                          :maxlength="form.refeicaoQuantidade.maxlength"
                          :state="form.refeicaoQuantidade.state"
                          :required="form.refeicaoQuantidade.required"/>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtInsured"><small v-show="form.refeicaoValorUnitario.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelValueMealPerDay}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
            <money class="form-control form-control-10 text-right"
                          v-bind="moneyFormat"
                          placeholder="R$ 0,00"
                          prefix="R$ "
                          v-model="form.refeicaoValorUnitario.value"
                          :maxlength="form.refeicaoValorUnitario.maxlength"
                          :required="form.refeicaoValorUnitario.required"
                          :state="form.refeicaoValorUnitario.state"/>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2 pb-2">
        <div class="col-md-6">
          <label for="txtInsured"><small v-show="form.valeAlimentacao.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelValueFood}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
            <money class="form-control form-control-10 text-right"
                          v-bind="moneyFormat"
                          :placeholder="'R$ 0,00'"
                          prefix="R$ "
                          v-model="form.valeAlimentacao.value"
                          :maxlength="form.valeAlimentacao.maxlength"
                          :required="form.valeAlimentacao.required"
                          :state="form.valeAlimentacao.state"/>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtInsured"><small v-show="form.cafeManhaValor.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelValueBreakfest}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
            <money class="form-control form-control-10 text-right"
                          v-bind="moneyFormat"
                          :placeholder="'R$ 0,00'"
                          prefix="R$ "
                          v-model="form.cafeManhaValor.value"
                          :maxlength="form.cafeManhaValor.maxlength"
                          :required="form.cafeManhaValor.required"
                          :state="form.cafeManhaValor.state"/>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2 pb-2 mt-4 mb-2" style="background-color: #ccc;">
        <div class="col-md-12">
          <strong><i class="fas fa-bus-alt"></i> {{$lang.EmployeeBoard.AddEmployee.GroupTransport}}</strong>
        </div>
      </div>
      <div class="form-group row pt-2 pb-2">
        <div class="col-md-6">
          <label for="txtInsured"><small v-show="form.valeTransporteQuantidade.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelQuantityTransport}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-calculator"></i></span>
            <money class="form-control form-control-10 text-right"
                          v-bind="integerFormat"
                          placeholder="0"
                          v-model="form.valeTransporteQuantidade.value"
                          :maxlength="form.valeTransporteQuantidade.maxlength"
                          :state="form.valeTransporteQuantidade.state"
                          :required="form.valeTransporteQuantidade.required"/>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtInsured"><small v-show="form.valeTransporteValorUnitario.required" class="text-danger">*</small> {{$lang.EmployeeBoard.AddEmployee.LabelValueTransport}}:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
            <money class="form-control form-control-10 text-right"
                          v-bind="moneyFormat"
                          :placeholder="'R$ 0,00'"
                          prefix="R$ "
                          v-model="form.valeTransporteValorUnitario.value"
                          :maxlength="form.valeTransporteValorUnitario.maxlength"
                          :required="form.valeTransporteValorUnitario.required"
                          :state="form.valeTransporteValorUnitario.state"/>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import AddEmployee from './addemployee.js'
export default AddEmployee
</script>

<style scoped>
.custom-group-addon {
  padding: 0.4rem 1rem;
  display: block;
  position: absolute;
  z-index: 9;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/employeeboard/board/components/addemployee/addemployee.vue